// https://vuex.vuejs.org/guide/modules.html
import mutations from "./mutations.js";

export default {
  namespaced: true,
  state: {
    signedIn: false,
    accessToken: "",
    loginTime: null,
    sessionExpirationMaxTime: 3600000, // 60 minutes
    beforeSessionExpirationMaxNotificationTime: 300000, // 5 minutes
    idleTime: 10000,
    wasIdle: false,
    isManuallySignedOut: false,
    isReminded: false,
    anyActiveTab: true,
    isSessionActive: false, // For session checking,
    errors: "",
    isLoginError: false,
    originToken: {
      accessToken: "",
      refreshToken: ""
    },
    tokenCheck: false
  },
  mutations
};
